import { useState } from 'react';

import { DIALOG_VARIANT } from 'constants/dialog';
import { USER_PERMISSIONS, USER_PERMISSIONS_CAPTIONS, USER_PERMISSIONS_LABELS } from 'constants/userPermissions';
import { formatEmailsList } from 'helper/formatEmailsList';
import { useDialog } from 'hooks/useDialog';
import { useCreateInvitesMutation } from 'store/entities/users/api';

export const useInviteUsers = (selectedOrganisationId) => {
  const [emailsList, setEmailsList] = useState([]);
  const [selectedPermission, setSelectedPermission] = useState(USER_PERMISSIONS.USER);
  const { openDialog } = useDialog();

  const [createInvites, { isLoading }] = useCreateInvitesMutation();

  const permissionsOptions = selectedOrganisationId
    ? [USER_PERMISSIONS.USER, USER_PERMISSIONS.ORGANISATION_ADMIN].map((permission) => ({
        id: permission,
        label: USER_PERMISSIONS_LABELS[permission],
        labelDescription: USER_PERMISSIONS_CAPTIONS[permission],
        value: permission,
      }))
    : [
        {
          id: USER_PERMISSIONS.SUPER_ADMIN,
          label: USER_PERMISSIONS_LABELS[USER_PERMISSIONS.SUPER_ADMIN],
          value: USER_PERMISSIONS.SUPER_ADMIN,
          disabled: true,
        },
      ];

  const inviteUsers = async () => {
    const data = {
      emails: formatEmailsList(emailsList),
      is_organisation_admin: selectedPermission === USER_PERMISSIONS.ORGANISATION_ADMIN,
      is_superadmin: !selectedOrganisationId,
      ...(selectedOrganisationId && { organisation: selectedOrganisationId }),
    };

    const { data: responseData } = await createInvites(data);

    if (responseData) {
      setEmailsList([]);
      setSelectedPermission(USER_PERMISSIONS.USER);

      if (responseData.invalid_emails?.length) {
        openDialog(DIALOG_VARIANT.INVALID_INVITES, {
          invalidInvites: responseData.invalid_emails,
          organisationId: selectedOrganisationId,
        });
      }
    }
  };

  return {
    isLoading,
    permissionsOptions,
    emailsList,
    inviteUsers,
    setEmailsList,
    selectedPermission: selectedOrganisationId ? selectedPermission : USER_PERMISSIONS.SUPER_ADMIN,
    setSelectedPermission,
  };
};
